import React from 'react'
import styles from "../Corpus/corpus.module.css"
import "../../App.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons'

export default function PlatoonList({platoons, chnageCompany, deleteCompany}) {
  return (
        <ol onClick={e => e.stopPropagation()}>
            <li className={styles["corpus-list-item"]}>
                <p className='per5 start'>Դասակի համար</p>
                <p className='per5 end'>Ղեկավարման կոճակներ</p>
            </li>
            {platoons?.map((el, index) => {
                return <li key={index} className={styles["corpus-list-item"]}>
                        <p className='per5 start'>{el?.platoon_number}</p>
                        <div className='per5 end flex justify-end'>
                            <button className={`btn cursor-pointer`} onClick={() => chnageCompany(el)}><FontAwesomeIcon icon={faPenToSquare} className={styles["edit"]} title="Խմբագրել"/></button>
                            <button className={`btn cursor-pointer`} onClick={() => deleteCompany(el)}><FontAwesomeIcon icon={faTrash} className={styles["edit"]} title="Ջնջել"/></button>
                        </div>
                    </li>
            })}
        </ol>
  )
}
